<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <m-search-item label="字典值">
                    <c-input name="name" maxlength="20"></c-input>
                </m-search-item>
                <m-search-item label="字典类型">
                    <c-select name="dic_type_id" async @search="searchDicType"></c-select>
                </m-search-item>
                <m-search-item label="状态">
                    <c-checkbox-group name="status" :options="disableEnableDic"></c-checkbox-group>
                </m-search-item>
                <m-search-item label="备注">
                    <c-input name="remark" maxlength="20"></c-input>
                </m-search-item>
                <m-search-item label="添加时间" colspan="2">
                    <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button color="main" v-if="auth('b_dic_info_edit')" prepend-icon="tf-add"
                          @click="$refs.dicInfoEdit.open()">添加字典值
                </c-button>
            </m-operate>

            <c-table ref="list" height="grow" :paging="true">
                <c-table-column
                        label="字典值代码"
                        name="code"
                        width="89"
                        fixed="left"
                >
                </c-table-column>

                <c-table-column
                        label="字典值"
                        name="name"
                        width="100"
                        fixed="left"
                >
                    <template #default="{data}">
                        <span v-if="data.color" :style="{'color': data.color}">{{data.name}}</span>
                        <span v-else>{{data.name}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="颜色"
                        name="color"
                        width="100"
                >
                </c-table-column>


                <c-table-column
                        label="字典类型"
                        name="dic_type_name"
                        width="150"
                >
                    <template #default="{data}">
                        <span>{{data.dic_type_name}}</span>
                    </template>
                </c-table-column>

                <!-- 是否启用 -->
                <c-table-column
                        label="状态"
                        name="status"
                        width="80"
                >
                    <template #default="{data}">
                        <c-switch v-if="auth('b_dic_info_edit')" v-model="data.status" :state-value="[1, 0]"
                                  :state-text="['启用','禁用']"
                                  @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
                        <c-state v-else dict="disableEnableDic" :value="data.status"></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                        label="备注"
                        name="remark"
                        width="150"
                >
                    <template #default="{data}">
                        <span v-if="data.remark">{{ data.remark }}</span>
                        <span v-else>-</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="添加人"
                        name="create_user_name"
                        width="80"
                >
                </c-table-column>

                <c-table-column
                        label="添加时间"
                        name="create_date"
                        width="130"
                >
                </c-table-column>

                <c-table-column
                        label="排序"
                        type="sort"
                        @handle="sortHandle">
                </c-table-column>

                <c-table-column
                        type="button"
                        label="操作"
                        width="150"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button v-if="auth('b_dic_info_edit')" icon="tf-edit" @click="$refs.dicInfoEdit.open(data)">编辑
                        </c-table-button>
                        <c-table-button v-if="auth('b_dic_info_edit')" icon="tf-trash" color="red" @click="removeDicInfo(data)">删除
                        </c-table-button>
                    </template>
                </c-table-column>
            </c-table>
            <!--添加/编辑字典值信息弹窗-->
            <dic-info-edit ref="dicInfoEdit" @resolve="$refs.list.update()"></dic-info-edit>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import dicInfoEdit from "@/pages/system/dic_info_edit.vue";

export default {
    components: {
        dicInfoEdit
    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['disableEnableDic'])
    },

    props: {
        type: String
    },

    data() {
        return {}
    },

    mounted() {
        this.searchHandle();
    },

    methods: {
        /*******搜索字典类型*****************/
        searchDicType(keyword, resolve) {
            this.request({
                url: '/dic/type/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /********搜索************/
        searchHandle(data) {
            if (!data) {
                data = {};
            }
            this.$refs.list.load({
                url: '/dic/info/list',
                data
            });
        },

        /******启禁用*********/
        stateHandle(state, next, data) {
            this.request({
                url: '/dic/info/edit/status',
                data: {
                    id: data.id,
                    status: state ? 2 : 1   //1：启用； 2：禁用
                },
                success: () => {
                    this.$message({
                        message: '操作成功',  // 提示内容,
                        type: 'success'
                    });
                    next();
                }
            })
        },

        /******删除字典值***********/
        removeDicInfo(data) {
            let dic_info_ids = [];
            dic_info_ids.push(data.id);
            this.$confirm({
                message: '确认删除字典值【' + data.name + '】？删除后不可恢复',  // 提示内容,
                // buttonName: '确定',  // 确定按钮文字
                cancelButton: true,  // 是否显示取消按钮
                resolve: () => {
                    this.request({
                        url: '/dic/del/info',
                        data: {
                            dic_info_ids: dic_info_ids
                        },
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',  // 提示内容,
                                type: 'success'
                            });
                            this.$refs.list.update();
                        }
                    });
                },  // 确定按钮回调
                cancel: () => {
                },  // 取消按钮回调
            });
        },

        /********************排序**************************/
        sortHandle(row, type, next) {
            this.request({
                url: '/dic/info/sort',
                data: {
                    id: row.data.id,
                    type: ['top', 'bottom'].includes(type) ? type : '',
                    id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
                    id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
                },
                loading: true,
                success: data => {
                    // next();
                    this.$refs.list.update();
                }
            });
        },
    }
}
</script>

<style lang="stylus" scoped>
</style>